import React from "react";
import ReactLoading from "react-loading";
import { Row, Col, Tabs, Tab, Nav } from "react-bootstrap";
import { Button } from "../../../../components/buttons";
import TabComponent from "./tabComponent";
import ActionToConvert from './actionToConvert';

export default function SearchResult(props) {
  return (
    <div className="container py-5 mborder rounded-bottom">
      <div className="card p-4" style={{ borderRadius: 16 }}>
        <Row>
          <Col lg={props.shortId ? 12:8} xs={12}>
            <div className="px-2 ">
              <TabComponent
                tracking={props.tracking}
                onClickCourier={props.onClickCourier}
                courierList={props.courierList}
              />
              {props.loading && (
                <div className="status-container align-items-center justify-content-center">
                  <ReactLoading type={"bubbles"} color={"#3B196C"} height={48} width={48} />
                  <strong>Menunggu Hasil</strong>
                </div>
              )}
            </div>
          </Col>
          {
            props.shortId ? null :
            <Col lg={4} xs={12}>
              <div className="position-sticky" style={{ top: "115px" }}>
                <div className="border mt-3 rounded">
                  <ActionToConvert
                    tracking={props.tracking}
                  />
                </div>
              </div>
            </Col>
          }
          
        </Row>
      </div>
    </div>
  );
}

{
  /* <Tabs defaultActiveKey="semua" id="uncontrolled-tab-example">
{tabs.map((tab) => (
  <Tab eventKey={tab[0]} title={tab[1]}>
    <FilteredResult
      filter={tab[0]}
      tracking={props.tracking}
      onClickCourier={props.onClickCourier}
    />
  </Tab>
))}
</Tabs> */
}

{
  /* <div className="container py-5 mborder rounded-bottom">
      <div className="mx-2 card px-0" style={{ borderRadius: 16 }}>
        <div className="px-4">
          <div className="row justify-content-center pb-4 pt-5 ">
            <a href={"/"}>
              <img src={`/images/logos/biteship.png`} alt={"Biteship Logo"} height={40} />
            </a>
          </div>
          {props.tracking.orderId ? (
            <div className="text-center">
              Nomor Pesanan: <b className="text-dark">#{props.tracking.orderId.toUpperCase()}</b>
            </div>
          ) : null}

          <hr />
          <h3 className={"h6 text-center lead "}>STATUS PENGIRIMAN</h3>
          <div className="row justify-content-center lead ">{spanStatus()}</div>
          <hr />
          <h3 className={"h6 text-center"}>DETAIL PENGIRIMAN</h3>
          <div>
            <b className="lead">
              <b>PENGIRIM</b>
            </b>
            <p className="lead">{props.tracking.originName}</p>
            <b className="lead">
              <b>PENERIMA</b>
            </b>
            <p className="lead m-0">{props.tracking.destinationName}</p>
            <p className="lead">Alamat: {props.tracking.destinationAddress}</p>
            <b className="lead">
              <b>KURIR</b>
            </b>
            <p className="lead">
              {normalizeCourierServices(props.tracking.courierCompany, "").companyName} -{" "}
              {
                normalizeCourierServices(
                  props.tracking.courierCompany,
                  props.tracking.courierService
                ).typeView
              }
            </p>
          </div>
        </div>

        <h3 className={"h6 text-center"}>INFORMASI PENGIRIMAN</h3>
        <div className="px-2 bg-lighter border rounded">
          <Timeline className={"bg-lighter border-top border-bottom px-0"}>
            {props.tracking.history.map((i, idx) => (
              <TimelineEvent
                key={idx}
                className="bg-lighter mb-3"
                title={courierBookingStatusDetails(i.status, props.tracking.courierCompany, idx)}
                titleStyle={{ fontWeight: "bold", fontSize: 18 }}
                createdAt={moment(i.eventDate).format("DD MMMM YYYY - HH:mm")}
                bubbleStyle={{
                  color: "white",
                  backgroundColor: "white",
                  borderColor: iconColor(i.status).color,
                }}
                iconStyle={iconColor(i.status)}
                style={{ fontSize: 16 }}
                icon={iconView(i.status)}
              >
                <div style={{ borderRadius: 16 }}>
                  <div className={"text-lg"}>{i.note}</div>
                </div>
              </TimelineEvent>
            ))}
          </Timeline>
        </div>
      </div>
    </div> 
    
    */
}
